import { render } from "./OapFlowplayer.vue?vue&type=template&id=f319d6e6"
import script from "./OapFlowplayer.vue?vue&type=script&lang=js"
export * from "./OapFlowplayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__